var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPngIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.3333 4.88889H10.3411M1 11.1111L4.88889 7.22222C5.61067 6.52766 6.50044 6.52766 7.22222 7.22222L11.1111 11.1111M9.55556 9.55555L10.3333 8.77777C11.0551 8.08322 11.9449 8.08322 12.6667 8.77777L15 11.1111M1 3.33333C1 2.71449 1.24583 2.121 1.68342 1.68342C2.121 1.24583 2.71449 1 3.33333 1H12.6667C13.2855 1 13.879 1.24583 14.3166 1.68342C14.7542 2.121 15 2.71449 15 3.33333V12.6667C15 13.2855 14.7542 13.879 14.3166 14.3166C13.879 14.7542 13.2855 15 12.6667 15H3.33333C2.71449 15 2.121 14.7542 1.68342 14.3166C1.24583 13.879 1 13.2855 1 12.6667V3.33333Z",
    stroke: "#88B88A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPngIcon);
export default __webpack_public_path__ + "static/media/png-icon.fa6d64c107afebebce279ea3d47a96dd.svg";
export { ForwardRef as ReactComponent };